import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'

import { changeNote, toggleNotes } from '../../actioncreators/actioncreators'

const MAX_NOTE_LENGTH = 2000

const Container = styled.div`
  background-color: #f4f5f7;
  display: flex;
  height: calc(100% - 48px);
  right: ${props => props.show ? `0px` : `-244px`};
  position: fixed;
  top: 48px;
  transition: right 0.25s ease-out;
  z-index: 1000;
`

const Drawer = styled.div`
  position: absolute;
  width: 30px
  height: 30px;
  left: -14px;
  top: 30px;
  cursor: pointer;
  background: ${props => props.pointLeft ? 'url("./img/arr_r.png") no-repeat' : 'url("./img/arr_l.png") no-repeat' };
  opacity: ${props => props.opaque ? 1 : 0 };
  transition: 0.25s;

  &:hover {
    background: ${props => props.pointLeft ? 'url("./img/arr_r_hov.png") no-repeat' : 'url("./img/arr_l_hov.png") no-repeat' };
  }
`

const DrawerTooltip = styled.div`
  background-color: black;
  border-radius: 10px;
  color: white;
  font-size: 0.8em;
  padding: 5px;
  position: absolute;
  right: 40px;
  text-align: center;
  top: 0px;
  visibility: ${props => props.show ? 'visible' : 'hidden'}
  transition: 0.25s;
  width: 75px;

  &::after {
    background: black;
    content: '';
    display: block;
    height: 13px;
    position: absolute;
    right: -3px;
    top: 7px;
    transform: rotate(-45deg);
    width: 13px;
    z-index: -1;
  }
`

const NotesPanel = styled.div`
  display: flex;
  flex-direction: column;
  padding: 5px;
`

const Text = styled.textarea`
  height: 100%;
  width: 250px;
  border-color: #ccc;
  border-radius: 4px;
  padding: 6px;
  resize: none;
`

const Notes = () => {
  const dispatch = useDispatch()
  const notesText = useSelector(state => state.notes.text)
  const show = useSelector(state => state.notes.show)
  const [hover, setHover] = useState(false)
  const [hoverDrawer, setHoverDrawer] = useState(false)

  const handleDrawerClick = () => {
    dispatch(toggleNotes())
    if (!show) {
      window.amplitude.getInstance().logEvent('em_notes_open')
    }
  }

  return (
    <Container show={show}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        >
      <Drawer opaque={hover || !show} pointLeft={show} onClick={handleDrawerClick} onMouseEnter={() => setHoverDrawer(true)} onMouseLeave={() => setHoverDrawer(false)}>
        <div>
          &nbsp;
        </div>
        <DrawerTooltip show={hoverDrawer}>
          { show ? 'Hide Notes' : 'Show Notes' }
        </DrawerTooltip>
      </Drawer>
      <NotesPanel>
        <span style={{ color: notesText.length === MAX_NOTE_LENGTH ? 'red' : 'black', textAlign: 'end' }}>{notesText.length} / {MAX_NOTE_LENGTH}</span>
        <Text value={notesText} onChange={e => dispatch(changeNote(e.target.value))} maxLength={MAX_NOTE_LENGTH} placeholder="Take some notes" style={{ visibility: show ? 'visible' : 'hidden'}} />
      </NotesPanel>
    </Container>
  )
}

export default Notes
